export default __webpack_public_path__ + "static/media/e-address.8c7e6764.png";